import React, { useEffect, useState } from 'react';
import { MealAddonsType, MealCategoryType } from 'utils/types';
import PageText from 'components/base/page-text';
import AddonCategoryCard from 'components/addon-category-card';
import useDashboardContext from 'contexts/dashboard.context';
import { apiService } from 'services/base.service';
import { toast } from 'react-toastify';
import { ToastMessage } from '@cokitchen/cokitchen-components';
import SearchNav from 'components/search-nav';
import DeleteModal from 'components/base/delete-modal';
import { ReactComponent as RestoreIcon } from 'assets/icons/restore.svg';

const TrashedAddons = () => {
  const { activeCokitchen } = useDashboardContext();
  const [addonList, setAddonList] = useState([] as MealAddonsType[]);
  const [selectedItems, setSelectedItems] = useState([] as string[]);
  const [showRestoreModal, setShowRestoreModal] = useState(false);
  const [activeAddon, setActiveAddon] = useState({} as MealAddonsType);

  const [loading, setLoading] = useState(false);

  const restoreBrand = () => {
    setShowRestoreModal(!showRestoreModal);
  };
  const removeAll = () => {
    setSelectedItems([]);
  };
  const handleSelectAll = () => {
    const allIds: string[] = addonList?.map((item: any) => item.id);
    setSelectedItems(allIds);
  };
  const restoreModal = () => {
    setShowRestoreModal(!showRestoreModal);
  };

  const fetchData = async () => {
    setLoading(true);
    const payload = { type: 'addon', cokitchen_id: activeCokitchen?.id };
    try {
      const res: any = await apiService.post('marketing/get-archived-items', { data: payload });
      const response = res?.data?.data;
      if (response) {
        setAddonList(res?.data?.data?.reverse());
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err.response.data.message} />);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, [activeCokitchen?.id]);

  const removeAddon = (id: string) => {
    setAddonList((prev) => prev.filter((item) => item.id !== id));
  };
  const handleChange = (category: MealCategoryType) => {
    //if (singleMeal?.id) setSingleMeal(null);
    const resultExists = selectedItems.find((item) => item === category.id);
    if (resultExists) {
      setSelectedItems(selectedItems.filter((item) => item !== category.id));
    } else {
      setSelectedItems([...selectedItems, category.id]);
    }
  };
  const handleRestoreClick = async () => {
    const itemIds = selectedItems.length > 0 ? selectedItems : [activeAddon.id];
    const payload = { type: 'addon', item_ids: itemIds };
    try {
      const res: any = await apiService.post('marketing/restore-bulk-items', { data: payload });
      if (res.data) {
        if (!activeAddon.id) {
          fetchData();
        }
        setAddonList((prev) => prev?.filter(({ id }) => id !== activeAddon.id));

        setShowRestoreModal(false);
        setSelectedItems([]);
        toast(
          <ToastMessage
            type='success'
            message={`Restored ${activeAddon.name || 'items'} successfully `}
          />
        );
        removeAddon(activeAddon?.id);
      }
    } catch (err: any) {
      toast(<ToastMessage type='error' message={err?.response.data.message} />);
    }
  };

  return (
    <div>
      {loading ? (
        <PageText text='Loading...' />
      ) : addonList.length === 0 && !loading ? (
        <PageText text='No addons found' />
      ) : (
        <div className='grid md:grid-cols-2 gap-4 items-center flex-wrap'>
          {addonList?.map((item: any) => (
            <div key={item?.id}>
              <AddonCategoryCard
                checked={selectedItems.includes(item?.id)}
                selectedItems={selectedItems}
                onChange={() => handleChange(item)}
                data={item}
                actions={
                  <RestoreIcon
                    className='cursor-pointer'
                    onClick={() => {
                      setActiveAddon(item);
                      setShowRestoreModal(!showRestoreModal);
                    }}
                  />
                }
                showCheckbox
              />
            </div>
          ))}
        </div>
      )}

      <DeleteModal
        show={showRestoreModal}
        type='restore'
        onClose={restoreModal}
        handleDelete={handleRestoreClick}
        title={`Are you sure you want to restore ${
          selectedItems.length > 0 ? 'items' : activeAddon?.meal_data?.name
        } `}
        description='This action will restore this addon'
        loading={loading}
      />
      {selectedItems.length > 0 && (
        <SearchNav
          count={selectedItems.length}
          handleSelectAll={handleSelectAll}
          onRestoreClick={restoreBrand}
          onDoneClick={removeAll}
        />
      )}
    </div>
  );
};

export default TrashedAddons;
